import React, {useEffect, useRef} from "react";
import L from "leaflet";
import {decodePolyline} from "../../../utils/helpers";

export const DeliveryRequestPolyline = ({mapInstance, polylineData, isVisible = true}) => {
    const polylineRef = useRef([]);

    useEffect(() => {
        if (!mapInstance || !polylineData?.polylines || !isVisible) {
            // Clear existing polylines if not visible
            if (polylineRef.current.length > 0) {
                polylineRef.current.forEach(polyline => {
                    mapInstance.removeLayer(polyline);
                });
                polylineRef.current = [];
            }
            return;
        }

        // Clear existing polylines
        if (polylineRef.current.length > 0) {
            polylineRef.current.forEach(polyline => {
                mapInstance.removeLayer(polyline);
            });
            polylineRef.current = [];
        }

        try {
            const decodedPath = decodePolyline(polylineData.polylines);

            // Convert decoded path to Leaflet format
            const leafletPath = decodedPath.map(point => [point.lat, point.lng]);

            // Create border polyline (thicker, blue)
            const borderPolyline = L.polyline(leafletPath, {
                color: "#0f53ff",
                weight: 8,
                opacity: 1.0
            });

            // Create main polyline (thinner, light blue)
            const mainPolyline = L.polyline(leafletPath, {
                color: "#6a83d7",
                weight: 5,
                opacity: 1.0
            });

            // Add polylines to map
            borderPolyline.addTo(mapInstance);
            mainPolyline.addTo(mapInstance);

            // Store references
            polylineRef.current = [borderPolyline, mainPolyline];
        } catch (error) {
            console.error("Error drawing polyline:", error);
        }

        return () => {
            // Cleanup on unmount
            if (polylineRef.current.length > 0) {
                polylineRef.current.forEach(polyline => {
                    if (mapInstance && mapInstance.removeLayer) {
                        mapInstance.removeLayer(polyline);
                    }
                });
                polylineRef.current = [];
            }
        };
    }, [mapInstance, polylineData, isVisible]);

    return null; // This component doesn't render anything directly
};
